import { ISbStoriesParams } from '@storyblok/react'

// check StoryBlok cache documentation for more information
const cv = new Date().getTime() / 1000
export let searchParamsData: ISbStoriesParams = {
  token: process.env.NEXT_PUBLIC_SB_PREVIEW_TOKEN,
  cv,
  version: process.env.NEXT_PUBLIC_SB_VERSION as 'published' | 'draft',
  fallback_lang: 'default',
}
